import { useMemo } from "react";
import { useRef, useState, useEffect } from "react";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { graphQL_shema } from "../utils/graphql";
import { useFormEvent } from "../utils/hooks";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { Uploadfile } from "../utils/upload";
import { useTranslation } from "react-i18next";
import "../../assests/icomoon/style.css";
import { useParams } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  DatePicker,
  Card,
  Checkbox,
  Form,
  Input,
  Row,
  Col,
  Select,
  Button,
  TimePicker,
  message,
  Spin,
  Tag,
  Tooltip,
  InputNumber
} from "antd";
import {
  PlusOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Tabs } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MoreOutlined,EditOutlined,DeleteOutlined } from "@ant-design/icons";
import { Menu,MenuItem } from "@material-ui/core";
import UploadDocuments from "../utils/uploadDocuments";
function AddEvents() {
   const [inputYoutube, setInputYoutube] = useState("");
   const [languageUrl, setLanguageUrl] = useState("");
   const [listLang, setListLang] = useState([]);
   const [countries, setCountries] = useState([]);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [form] = Form.useForm();
  const history = useHistory();
  const { Option } = Select;
  const { TabPane } = Tabs;
  const [formWait, setFormWait] = useState(false);
  const [eventID, setEventID] = useState(null);
  const [leave, setLeave] = useState(true);
  const [loadingStart, setLoadingStart] = useState(false);
  const [initialTypeEvent] = useState(
    localStorage.getItem("initialTypeEvent")
  );
  const idUser = localStorage.getItem("idUser")
  const action =localStorage.getItem("action")
  const [idVideo, setIdVideo] = useState(localStorage.getItem(null));
  const [, setLangages] = useState([]);

  const [initialfilelist, setInitialfilelist] = useState([]);
  const [initialuploadFile, setInitialuploadFile] = useState("");
  const [initialuploadDoc, setInitialUploadDoc] = useState([]);

  const [activeKey, setActiveKey] = useState("1");
  const [tags, setTags] = useState([]);
  const [eventStatus, setEventStatus] = useState(-2);
  const { language, id } = useParams();
  const dispatch = useDispatch();
  const [menuAnchor,setMenuAnchor] = useState(null);
  const [open,setOpen] = useState(false);
  const currentStatus = useSelector((state) => state.reducer.currentStatus);
  const isSDIstation = useSelector((state) => state.reducer.isSDIstation);
  const loader = useSelector((state)=>state.reducer.setLoader);
  const handleOpenMenu = (e)=>{
    setMenuAnchor(e.currentTarget);
    setOpen(!open)
  }
  const handleCloseMenu = () =>{
  setMenuAnchor(null);
    setOpen(false)
    
  
  }
  var arr = ["en", "fr", "or"];

  var dataLang = [
    { value: 'FL', label: t('language.FL1') },
    { value: 'EN', label: t('language.Anglais') },
    { value: 'SP', label: t('language.ES') },
    { value: 'FR', label: t('language.Français') },
    { value: 'RU', label: t('language.RU')},
    { value: 'AR', label: t('language.AR') },
    { value: 'ZH', label: t('language.ZH') },
  ];

  
  const [initialState, setInitialState] = useState({
    Orateur: false,
    Français: false,
    Anglais: false,
    autre: false,
    langs: [],
    stationID: "",
    stationName: "",
    themeIds: [],
    themeName: "",
    categoryId: "",
    categoryName: "",
    title: "",
    description: "",
    startHour: "",
    finalHour: "",
    richMediaPresentation: false,
    vodRecord: true,
    downloadable: true,
    isAuto: false,
    ProcessorGUID:"",
    VideoPortIndex:0,
    AudioPortIndex:0,
    ProtocolType:"srt",
    isDvr: false,
    isVisibleOnInternet: true,
    copyright: "",
    keyWords: "",
    organizerName: "",
    organizerEmail: "",
    smsCount: "",
    comment: "",
    isSecuredOnInternet: false,
    passwordInternet: "",
    logo: "",
    startDate: "",
    timeStart: "",
    timeStop: "",
    StartRecord: -1,
    forbideanlanguage: "",
    videoDisplay: [],
    logoUrl: "",
    youtubeLinks: {},
    isYoutube:false,
    countries:[],
    documents:[]
  });

  const enabledYTB = useSelector(state=>state.reducer.selectedYTB)
  const handleEditInputChange = (e) => {
    setEditInputValue(e.target.value);
  };
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const ALLOWED_EXTENSIONS = ["jpeg", "png", "apng", "avif", "gif", "svg", "webp"];

  const acceptString = ALLOWED_EXTENSIONS.map(ext => `image/${ext}`).join(', ');
  
  const handleEditInputConfirm = () => {
        const newTags = [...tags];
    newTags[editInputIndex] = editInputValue;
    setTags(newTags);
    setEditInputIndex(-1);
    setInputValue("");
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
        if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
      onChangeKeywords([...tags, inputValue]);
    }
      setInputVisible(false);
    setInputValue("");
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleClose = (removedTag) => {
    const newTags = tags?.filter((tag) => tag !== removedTag);
    setTags(newTags, "new tags");
    onChangeKeywords(newTags);
  };

  const {
    loading,
    data: GetINFO,
  } = useQuery(graphQL_shema().Get_Stations_Themes_Categories, {
    variables: { empty: "" },
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      storeInfos(data);
      if (
        (location.state && location.state.action === "create") ||
        (!location.state && action === "create")
      ) {
        setInitialState(
          Object.assign(initialState, {
            themeIds: [GetINFO.getInfoForm.themes[0].id],
            categoryId: GetINFO.getInfoForm.categories[0].id,
            stationID: GetINFO.getInfoForm.stations[0].id,
            themeName: GetINFO.getInfoForm.themes[0].title,
            categoryName: GetINFO.getInfoForm.categories[0].title,
            stationName: GetINFO.getInfoForm.stations[0].name,
            langs: selectedValues,
            videoDisplay: ["vodRecord", "downloadable", "isVisibleOnInternet"],
            startHour: moment(moment(), "HH:mm"),
            startDate: moment(moment(), "YYYY-MM-DD"),
          })
        );
        form.setFieldsValue(initialState);
      }
    },
  });

  const [GET_LANGUES ] =
    useLazyQuery(graphQL_shema().Get_langues, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        let allLanguages = data.getLanguages;
        let filtredLanguages = allLanguages.filter(
          (lang) => !arr.includes(lang.label)
        );
        setLangages((languages) =>
          Object.assign(...languages, filtredLanguages)
        );
      },
    });

  useQuery(graphQL_shema().getEvent_byID, {
    fetchPolicy: "no-cache",
    skip: id ? false : true,
    variables: {id:id,lang:i18n.language ?? 'fr'},
    onCompleted: async (EditEventData) => {
      setListLang(EditEventData.getEventByID.videoMedia.youtubeLinks.links);
      await setInitialState(
        Object.assign(initialState, {
          Orateur:
            EditEventData.getEventByID.videoMedia.langs.indexOf("or") === -1,
          Français:
            EditEventData.getEventByID.videoMedia.langs.indexOf("fr") === -1,
          Anglais:
            EditEventData.getEventByID.videoMedia.langs.indexOf("en") === -1,
          autre: !EditEventData.getEventByID.videoMedia.langs.some((lang) =>
            dataLang?.map((item) => item.value).includes(lang)
          ),
          langs: EditEventData.getEventByID.videoMedia.langs,
          stationID: EditEventData.getEventByID.eventOrganizer.stations.id,
          stationName: EditEventData.getEventByID.eventOrganizer.stations.name,
          stationAuto: EditEventData.getEventByID.eventOrganizer.stations.IsAuto,
          themeIds: EditEventData.getEventByID.videoMedia.video.themes.map(({ id }) => id),
          themeName: EditEventData.getEventByID.videoMedia.video.themes.map(({ title }) => title),
          categoryId: EditEventData.getEventByID.eventOrganizer.categorys.id,
          categoryName:
            EditEventData.getEventByID.eventOrganizer.categorys.title,
          title: EditEventData.getEventByID.videoMedia.video.title,
          description: EditEventData.getEventByID.videoMedia.video.description,
          startHour: moment
            .utc(
              EditEventData.getEventByID.eventOrganizer.timeStart
                .toString()
                .substring(
                  EditEventData.getEventByID.eventOrganizer.timeStart.indexOf(
                    "T"
                  ) + 1
                ),
              "HH:mn:ss"
            )
            .local(),
          finalHour: moment
            .utc(
              EditEventData.getEventByID.eventOrganizer.timeStop
                .toString()
                .substring(
                  EditEventData.getEventByID.eventOrganizer.timeStop.indexOf(
                    "T"
                  ) + 1
                ),
              "HH:mn:ss"
            )
            .local(),
          richMediaPresentation:
            EditEventData.getEventByID.eventOrganizer.richMediaPresentation,

          vodRecord: EditEventData.getEventByID.eventOrganizer.vodRecord,
          downloadable:
            EditEventData.getEventByID.videoMedia.video.downloadable,
          isVisibleOnIntranet:
            EditEventData.getEventByID.videoMedia.video.isVisibleOnIntranet,
          isVisibleOnInternet:
            EditEventData.getEventByID.videoMedia.video.isVisibleOnInternet,
          isAuto: EditEventData.getEventByID.eventOrganizer.isAuto,
          ProcessorGUID: EditEventData.getEventByID.eventOrganizer.ProcessorGUID,
          VideoPortIndex:  EditEventData.getEventByID.eventOrganizer.VideoPortIndex?EditEventData.getEventByID.eventOrganizer.VideoPortIndex:0,
          AudioPortIndex:EditEventData.getEventByID.eventOrganizer.AudioPortIndex?EditEventData.getEventByID.eventOrganizer.AudioPortIndex:0,

          ProtocolType:EditEventData.getEventByID.eventOrganizer.ProtocolType?EditEventData.getEventByID.eventOrganizer.ProtocolType:"srt",
          
          isDvr: EditEventData.getEventByID.eventOrganizer.isDvr,
          isYoutube:EditEventData.getEventByID.eventOrganizer.isYoutube,
          StartRecord: EditEventData.getEventByID.eventOrganizer.StartRecord,
          copyright: EditEventData.getEventByID.videoMedia.video.copyright,
          url: EditEventData.getEventByID.eventOrganizer.url,
          urlTitle: EditEventData.getEventByID.eventOrganizer.urlTitle,
          keyWords: EditEventData.getEventByID.videoMedia.video.keyWords,
          organizerName:
            EditEventData.getEventByID.eventOrganizer.organizerName,
          organizerEmail:
            EditEventData.getEventByID.eventOrganizer.organizerEmail,
          smsCount: EditEventData.getEventByID.eventOrganizer.smsCount,
          accessType: EditEventData.getEventByID.eventOrganizer.accessType,
          comment: EditEventData.getEventByID.eventOrganizer.comment,
          isSecuredOnInternet:
            EditEventData.getEventByID.videoMedia.video.isSecuredOnInternet,
          passwordInternet:
            EditEventData.getEventByID.videoMedia.video.passwordInternet,
          countries: Array.from(EditEventData.getEventByID.videoMedia.video.countries,({id})=>id)?? [],
          logo: EditEventData.getEventByID.videoMedia.logoName,
          logoUrl: EditEventData.getEventByID.videoMedia?.video?.logo,
          youtubeLinks: EditEventData.getEventByID.videoMedia.youtubeLinks.links,
          startDate: moment
            .utc(
              EditEventData.getEventByID.eventOrganizer.timeStart
                .toString()
                .substring(
                  0,
                  EditEventData.getEventByID.eventOrganizer.timeStart.indexOf(
                    "T"
                  )
                ),
              "YYYY-MM-DD"
            )
            .local(),
          videoDisplay: [],
          documents:[]
        })
      );
      setEventStatus(EditEventData.getEventByID.eventOrganizer.StartRecord)
      setTags(EditEventData.getEventByID.videoMedia.video.keyWords && EditEventData.getEventByID.videoMedia.video.keyWords?.split(" "));
      if (EditEventData.getEventByID.videoMedia.video.logo) {
        setInitialfilelist(
          Object.assign(initialfilelist, [
            {
              uid: "1",
              name: EditEventData.getEventByID.videoMedia.logoName,
              status: "done",
              url: EditEventData.getEventByID.videoMedia.video.logo,
              thumbUrl: EditEventData.getEventByID.videoMedia.video.logo,
            },
          ])
        );
      }
      setInitialuploadFile(EditEventData.getEventByID.videoMedia.logoName);
      setInitialUploadDoc(EditEventData.getEventByID.videoMedia.video.filesVideo)
        dispatch({
        type: "UPLOAD_LOGO_THEME",
        payload: EditEventData.getEventByID.videoMedia.logoName || "",
      });
      // add inital docs
      let replacedValues = [];

      initialState.langs.forEach((e, index) => {
        if (dataLang.indexOf(e) === -1) {
          replacedValues.push(e);
          setInitialState((prevState) => ({
            ...prevState,
            forbideanlanguage: e,
            langs: [...prevState.langs.slice(0, index), dataLang, ...prevState.langs.slice(index + 1)],
          }));
        }

      setSelectedValues(replacedValues)
      });
      initialState.richMediaPresentation &&
        (await initialState.videoDisplay.push("richMediaPresentation"));

      initialState.vodRecord &&
        (await initialState.videoDisplay.push("vodRecord"));
      initialState.downloadable &&
        (await initialState.videoDisplay.push("downloadable"));
        initialState.isAuto &&
        (await initialState.videoDisplay.push("isAuto"));
        initialState.ProcessorGUID &&
        (await initialState.videoDisplay.push("ProcessorGUID"));

        initialState.VideoPortIndex &&
        (await initialState.videoDisplay.push("VideoPortIndex"));
        initialState.AudioPortIndex &&
        (await initialState.videoDisplay.push("AudioPortIndex"));
        initialState.ProtocolType &&
        (await initialState.videoDisplay.push("ProtocolType"));

        initialState.isDvr &&
        (await initialState.videoDisplay.push("isDvr"));
        initialState.isYoutube &&
        (await initialState.videoDisplay.push("isYoutube"));
      initialState.isVisibleOnInternet &&
        (await initialState.videoDisplay.push("isVisibleOnInternet"));
      initialState.isSecuredOnInternet &&
        (await initialState.videoDisplay.push("isSecuredOnInternet"));

      initialState.isYoutube.videoDisplay &&
      (await initialState.videoDisplay.push("isYoutube"))
     
      initialState.videoDisplay.indexOf("isVisibleOnInternet") === -1 &&
        (await setInitialState(
          Object.assign(initialState, { isSecuredOnInternet: false })
        ));
      await form.setFieldsValue(initialState);
      setIdVideo(EditEventData.getEventByID.videoMedia.video.id);
      id && setEventID(id);
      await setFormWait(true);
    },
  });
  let { onDelete, fileList,uploadFile,setCropper ,getCropData} = Uploadfile(
    initialfilelist,
    initialuploadFile
  );
  const uploadFileUrl = useSelector(state=>state.reducer.logo)
  const uploadLogoUrl = useSelector(state=>state.reducer.urlLogo)
  const { event_module } = useSelector(
    (state) => state.ReducerUserData.modules
  );

 
  useEffect(()=> {
    if(event_module?.countries_event_action?.authorized)
   { getCountries(i18n.language).then((res)=> {
      setCountries(res?.data?.data)
    }).catch(()=> setCountries([]))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const {
    onChange,
    onChangeKeywords,
    onChange_select,
    handleCountriesSelect,
    onChange_Number,
    onChange_datePicker,
    onChange_dateTime_fin,
    onChange_dateTime_debut,
    onChange_checkbox,
    onSubmit,
    disablePastDate,
    startGetDisabledHours,
    FinalGetDisabledHours,
    startGetDisabledMinutes,
    finalGetDisabledMinutes,
    handleLangSelect,
    values,
    variables,
    getCountries,
    storeInfos
  } = useFormEvent(
    location.state
      ? location.state.action === "update"
        ? updateEvent
        : registerEvent
      : registerEvent,
    "",
    initialState,
    eventID,
    form,
    location.state && location.state.idUser ? location.state.idUser : idUser,
    uploadFile,
    language,
    uploadFileUrl,
    languageUrl,
    inputYoutube,
    listLang,
    initialuploadDoc
  );
  const handleChangeLang = (selectedValues,action) => {
    setSelectedValues(selectedValues);
    handleLangSelect(action);
  };
  const [createEvent] = useMutation(graphQL_shema().CREATE_EVENT, {
    variables: variables,
    onCompleted: (data) => {
      setLoadingStart(false);
      switch (data.createEventOrganizer.code) {
        case "200":
          history.goBack()
          success_submit();
          window.parent.postMessage(
            {
              info: "event",
              value:  currentStatus === "live" ? 'ongoing':currentStatus ,
            },
            "*"
          )
          break;
        case "401":
          leave && error_submit(401);
          break;
        case "402":
          leave && error_submit(402);
          break;
        case "400":
          if (data.createEventOrganizer.message === "Conference key exist") {
            leave && error_submit(403);
          } else if (
            data.createEventOrganizer.message ===
            "several live on same encoder at the same time"
          ) {
            leave && error_submit(404);
          } else {
            leave && error_submit(402);
          }
          break;
        case "405":
          leave && error_submit(405);
          break;
        default : 
        break
      }
    },
  });

  function registerEvent(submissionVariables) {
    createEvent({ variables: submissionVariables || variables });
  }

const [UpdateEvent] = useMutation(graphQL_shema().UPDATE_EVENT, {
  variables: variables,
  onCompleted: async (data) => {
    switch (data.updateEventOrganizer.code) {
      case "200":
        history.goBack();
        leave && success_submit();
        window.parent.postMessage(
          {
            info: "event",
            value:  currentStatus === "live" ? 'ongoing':currentStatus ,
          },
          "*"
        )
        break;
      case "401":
        leave && error_submit(401);
        break;
      case "402":
        leave && error_submit(402);
        break;
      case "400":
        if (
          data.updateEventOrganizer.message ===
          "several live on same encoder at the same time"
        ) {
          error_submit(404);
        }
        else if (
          data.updateEventOrganizer.message.includes(
            "Field validation for 'StartRecord'"
          )
        ) {
          leave && error_submit(409);
        } else {
          leave && error_submit(402);
        }
        break;
      case "405":
        leave && error_submit(405);
        break;
      default:
        console.log("Unhandled error code:", data.updateEventOrganizer.code);
        break;
    }
  },
});


  function updateEvent(submissionVariables) {
    UpdateEvent({ variables: submissionVariables || variables });
  }

  const [StopEventActivation] = useMutation(graphQL_shema().Stop_Event, {
    variables: {
      idVideo: idVideo,
      endDate: moment().tz("Europe/Paris").format("YYYY-MM-DDTHH:mm:ss+01:00"),
    },
    onCompleted: async (data) => {
      history.push("/");
    },
  });

  const StopEvent = () => {
    StopEventActivation();
  };

  const success_submit = () => {
    setLeave(false);
    message.success({
      onClick: () => {
        setLeave(false);
      },
      content: eventID ? t("Translate.200-1") : t("Translate.200-2"),
      duration: 2,
      onClose: () => {
        setLeave(true);
      },
      style: {
        marginTop: "2vh",
      },
    });
  };

  const error_submit = (code) => {
    const messageERROR = {
      401: eventID ? t("Translate.401-1") : t("Translate.401-2"),
      402: eventID ? t("Translate.402-1") : t("Translate.402-2"),
      400: t("Translate.403-1"),
      405: eventID ? t("Translate.404-1") : t("Translate.404-2"),
      403: t("Translate.403-2"),
      404: t("Translate.404-3"),
      409: t("Translate.402-9"),
    };
    setLeave(false);
    message
      .error({
        content: messageERROR[code],
        duration: 2,
        onClick: () => {
          setLeave(false);
        },
        onClose: () => {
          setLeave(true);
        },
        style: {
          marginTop: "2vh",
        },
      })
      .then(() => setLeave(true));
  };
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState("");

const [OpenMenu, setOpenMenu] = useState(false);
const [isEnabled, setIsEnabled] = useState(false);
const [, setIsEnabledButton] = useState(false);
const [duplicateError, setDuplicateError] = useState("");
const [copyMessages, setCopyMessages] = useState([]);
const [selectedLanguages, setSelectedLanguages] = useState([]);

const handleLanguageSelect = () => {
  // Check if the selected language is not already in the list
  if (!selectedLanguages.includes(languageUrl)) {
    setSelectedLanguages([...selectedLanguages, languageUrl]);
  }
};
// Calculate isAuto using useMemo
const isAutoStation = useMemo(() => {
  const stations = GetINFO?.getInfoForm?.stations;
  const stationId = values?.stationID;
  if (stations && stations.length && stationId) {
    const station = stations.find((s) => s.id === stationId);
    return station?.IsAuto ?? false;
  }
  return false;
}, [GetINFO, values?.stationID]);

// Update state only when isAuto changes


const options = [
  { value: "fr", label: "Fr" },
  { value: "en", label: "En" },
  { value: "ar", label: "Ar" },
  { value: "fl", label: "FL" },
  { value: "sp", label: "SP" },
  { value: "ch", label: "Ch" },
  { value: "ru", label: "Ru" },
  { value: "zh", label: "Zh" },
].map((option) => ({
  ...option,
  disabled: listLang?.some((lang) => lang.lang === option.value),
}));

const handleCheckboxChange = (e) => {
  setIsEnabled(!isEnabled);
};
const [errorUrl,setErrorUrl]= useState(false)

const isValidUrl = (url) => {
    if (!url || !url.trim()) {
        return false;
    }

    try {
        const trimmedUrl = url.trim();

        const normalizedUrl = /^https?:\/\//i.test(trimmedUrl)
            ? trimmedUrl
            : `https://${trimmedUrl}`;

        const parsedUrl = new URL(normalizedUrl);
        const host = parsedUrl.hostname.toLowerCase().replace(/^www\./, "");
        const pathParts = parsedUrl.pathname.split("/").filter(Boolean);

        let videoId = "";

        if (host === "youtu.be") {
            videoId = pathParts[0] || "";
        } else if (
            host === "youtube.com" ||
            host === "youtube-nocookie.com"
        ) {
            if (parsedUrl.pathname === "/watch") {
                videoId = parsedUrl.searchParams.get("v") || "";
            } else if (pathParts[0] === "watch") {
                videoId = pathParts[1] || "";
            } else if (["embed", "v", "e", "shorts", "live"].includes(pathParts[0])) {
                videoId = pathParts[1] || "";
            }
        }

        return /^[A-Za-z0-9_-]{11}$/.test(videoId);
    } catch (error) {
        return false;
    }
};

const handleInputYoutubeChange = (e) => {
  setInputYoutube(e.target.value);
  setIsEnabledButton(e.target.value.trim() !== ""|| isValidUrl(e.target.value) === true);
  const hasDuplicateLink = listLang?.some(lang => lang.link === e.target.value || lang.link === e.target.value);


  const allLinksValid = listLang?.every(lang => isValidUrl(lang.link));
  const hasEmptyLink = listLang?.some(lang => !lang.link.trim());

  if (hasDuplicateLink) {
    setDuplicateError(t("Translate.Input"));

    setEnable(true);

    return;
  }
  if (!allLinksValid && !hasEmptyLink) {
    setErrorMessage(t("Translate.validUrl"));

    setEnable(true);
    return;
  }

  if (hasEmptyLink) {
    setErrorMessage(t("Translate.emptyInput"));
    setEnable(true);
    return;
  }
  if (e.target.value === "" || !e.target.value ) {
    setErrorMessage(t("Translate.emptyInput"));
    setEnable(true);
    setErrorUrl(false)
    return;
  } else {
    if(isValidUrl(e.target.value) === false && e.target.value !== ""){
      setErrorUrl(true)
      setErrorMessage("");

    }else{
      setErrorUrl(false)
    }
    setIsEnabledButton(false);
    setErrorMessage("");
    setEnable(false);
   setDuplicateError("");
  }
};

const handleCopyClick = (inputId, index, e) => {
  const inputElement = document.getElementById(inputId);
  if (inputElement) {
    inputElement.select();
    document.execCommand("copy");
    const newCopyMessages = [...copyMessages];
    newCopyMessages[index] = "Copied!";
    setCopyMessages(newCopyMessages);
    e.target.style.filter =
      "invert(37%) sepia(100%) saturate(1535%) hue-rotate(193deg) brightness(103%) contrast(101%)";
    setTimeout(() => {
      e.target.style.filter =
        "invert(0%) sepia(93%) saturate(29%) hue-rotate(133deg) brightness(93%) contrast(107%)";
    }, 3000);
  }
};

const [,setEditLink] = useState("")
const [,setEditLanguage] = useState("")
const handleAjouter = () => { 
  const hasDuplicateLink = listLang.some((lang, index) => {
    return listLang?.slice(index + 1, listLang?.length).some(innerLang => innerLang.link === lang.link);
  });

  if (hasDuplicateLink) {
    setDuplicateError(t("Translate.Input"));
    setEnable(true);
    return;
  }

  const checkDuplication = listLang?.some(el => el.link === inputYoutube);
  if (checkDuplication) {
    setEnable(true);
    return;
  }

  const allLinksValid = listLang?.every(lang => isValidUrl(lang.link));
  const hasEmptyLink = listLang?.some(lang => !lang.link.trim()) || !inputYoutube;
  if (!allLinksValid && !hasEmptyLink) {
    setErrorMessage(t("Translate.validUrl"));
    setEnable(true);
    return;
  }
   if (!languageUrl && hasEmptyLink) {
    setErrorMessage(t("Translate.emptyFields"));
    setEnable(true);
    return;
  }
  
   if (!languageUrl) {
    setErrorMessage(t("Translate.emptyLanguage"));
    setEnable(true);
    return;
  }
  else {
    setEnable(false)
  }
  if (hasEmptyLink) {
    setErrorMessage(t("Translate.emptyInput"));
    setEnable(true);
    return;
  }
  else 
  setEnable(false)
  setDuplicateError("")
  languageUrl &&
    inputYoutube  &&
  setListLang((prevList) => {
    return [
      ...prevList,
      {
        id: prevList.length + 1,
        lang: languageUrl,
        link: inputYoutube,
      },
    ];
  });

  setInputYoutube("");
  setLanguageUrl("");
  setIsEnabled(false);
  handleLanguageSelect();
  setEnable(false);
  setErrorMessage("");
};
const handleEditYoutubeLinks = (e,index) => {
  const updatedList = [...listLang];
  const newLink = e.target.value.trim();
  updatedList[index].link = newLink;
  const checkDuplication = listLang?.some((el, i) => i !== index && el.link === newLink);
  const allLinksValid = listLang?.every(lang => isValidUrl(lang.link));
  const hasEmptyLink = listLang?.some(lang => !lang.link.trim());
  const hasDuplicateLink = listLang?.some((lang, index) => {
    return listLang?.slice(index + 1, listLang?.length).some(innerLang => innerLang.link === lang.link );
  });
  if (hasDuplicateLink || listLang?.some(lang => lang.link === inputYoutube)) {
    setDuplicateError(t("Translate.Input"));
    setErrorMessage(t(""));

    setEnable(true);
    return;
  }
  if (!allLinksValid && !hasEmptyLink) {
    setErrorMessage(t("Translate.validUrl"));
    setDuplicateError(t(""));
    setEnable(true);
    setIsEnabledButton(false);

    return;
  }

  if (hasEmptyLink) {
    setErrorMessage(t("Translate.emptyInput"));
    setDuplicateError(t(""));

    setEnable(true);
    return;
  }
  if (checkDuplication) {
    setDuplicateError(t("Translate.Input"));
    setErrorMessage("");
    setEnable(true);
    setIsEnabledButton(false);

    return;
  } else {
    setDuplicateError("");
  }
  setIsEnabledButton(e.target.value.trim() !== ""|| isValidUrl(e.target.value) === true);
  if(e.target.value==="")  {
    setErrorMessage(t("Translate.emptyInput"));
    setIsEnabledButton(true);
    setEnable(true)
    setErrorUrl(false)

    }
  if (e.target.value === "" || !e.target.value ) {
   
    setEnable(true);
    
    return;
  } else {
    if(isValidUrl(e.target.value) === false && e.target.value !== ""){
      setErrorUrl(true)
      setErrorMessage("");
    } 

      else{
      setErrorUrl(false)
    }
    setIsEnabledButton(false);
    setErrorMessage("");
    setEnable(false);
   setDuplicateError("");

  }
  setListLang(updatedList);
  setEditLink(e.target.value);
 }

  const themesList = useSelector((state) => state.reducer.themes);
  const [optionThemes, setOptionThemes] = useState([]);
  useEffect(() => {
const flatten = (arr, originalPos = 1, result = [], parent= true, child= false) => {
for (let i = 0, length = arr.length; i < length; i++) {
   const value = arr[i];
  const pos = originalPos;
  value.pos = pos;
  value.parent = parent;
  value.child = child;
  result.push(value);
  if (Array.isArray(value.themes) && value.themes.length > 0) {
  flatten(value.themes, pos + 1, result, false, true);
  }
 }
 return result;
}
const themesBychannels = themesList?.channels ? themesList?.channels : {};
var channels = Object.values(themesBychannels);
let result = [];
for (let i = 0, length = channels.length; i < length; i++) {
var value = channels[i];
value.disabled = true;
value.pos = 0;
channels[i].themes = flatten(channels[i].themes);
result = result.concat(channels[i]);
}
setOptionThemes(result)
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [themesList])


  const inputRef = useRef(null);
  const editInputRef = useRef(null);
  useEffect(() => {
    initialState?.keyWords?.length
      ? setTags(initialState?.keyWords?.split(" "))
      : setTags([]);
      if(initialState.youtubeLinks){
        dispatch({type:"SET_SELECTED_YTB",payload:listLang?.length > 0 ? true : false})
      }
      else if(listLang?.length === 0) {  
         dispatch({
           type: "SET_SELECTED_YTB",
           payload:false,
         });
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState?.keyWords,enabledYTB,listLang?.length]);
  
useEffect(()=>{
  setImage(initialState?.logoUrl)
  if(image ==null){
    dispatch({ type: "UPLOAD_LOGO_URL", payload: "" });
  }
  if(isCropped === false){
    dispatch({type:"SET-CROPPED",payload:true})
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[initialState?.logoUrl])
  useEffect(() => {
    GET_LANGUES();
    location.state && localStorage.setItem("action", location.state.action);
    location.state &&
      location.state.event &&
      localStorage.setItem("eventID", location.state.event.id);
    location.state && localStorage.setItem("idUser", location.state.idUser);
    location.state &&
      localStorage.setItem("initialTypeEvent", location.state.initialTypeEvent);

    !id && setFormWait(true)
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 const isValidPassword = (password) => {
    const regex = /^(?=(?:.*[a-z])?)(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()^_!"#$%&'*+£,-.  :;{}<>=|~?·•¯‾|¦‍†‡§¶©®™&@/◊♠♣♥♦←↑→↓↔áÁâÂàÀåÅãÃäÄæÆçÇéÉêÊèÈëËíÍîÎìÌïÏñÑóÓôÔòÒøØõÕöÖœŒšŠßðÐÞúÚûÛùÙüÜýÝÿŸ¤€$¢£¥ƒαΑβΒγΓδΔεΕζΖηΗθΘιΙκΚλΛμΜνΝξΞοΟπΠρΡσςΣτΤυΥφΦχΧψΨωΩ°µ<≤≥=≈≠≡±−+×÷⁄%‰¼½¾¹²³ºªƒ″∂∏∑√∞¬∩∫])[a-zA-Z\d@$!%*?&()^_!"#$%&'*+£,-. :;{}<>=|~?·•¯‾|¦‍†‡§¶©®™&@/◊♠♣♥♦←↑→↓↔áÁâÂàÀåÅãÃäÄæÆçÇéÉêÊèÈëËíÍîÎìÌïÏñÑóÓôÔòÒøØõÕöÖœŒšŠßðÐÞúÚûÛùÙüÜýÝÿŸ¤€$¢£¥ƒαΑβΒγΓδΔεΕζΖηΗθΘιΙκΚλΛμΜνΝξΞοΟπΠρΡσςΣτΤυΥφΦχΧψΨωΩ°µ<≤≥=≈≠≡±−+×÷⁄%‰¼½¾¹²³ºªƒ″∂∏∑√∞¬∩∫]{8,}$/;
    return regex.test(password);
};



  const isValidVideo = (option) => {
    return option.some(
      (r) => ["isVisibleOnIntranet", "isVisibleOnInternet"].indexOf(r) >= 0
    );
  };

    const isValideTempFinal = (value, checkedvalue) => {
    if (
      values.startDate.format("YYYY-MM-DD") ===
      moment().format("YYYY-MM-DD")
    ) {
      if (!moment(moment(), "HH").isBefore(values.finalHour))
        return false;
      else return !value.isSameOrAfter(checkedvalue);

    } else if(value.isSameOrAfter(checkedvalue) === true){
      return false
    }
    
    else return true;
  };
  const isValideTempStart = (value, checkedvalue) => {
    const currentHour = moment().utcOffset(0);
    if (values.startDate.isSame(currentHour, 'day')) {
      if(eventStatus!==0){
        if (value.isSameOrAfter(currentHour, 'hour')) {
          return true; 
        } 
        else  if(value.isBefore(currentHour, 'hour')){
          return false; 
        }
      }else{
        return true
      }

    } 
    else {
        return true;
    }
  };

  const requiredFieldRule = [
    { required: true, message: t("Message.FieldsRequired") },
  ];

  

  const [errorState, setErrorState] = useState({
    errorPage1: 0,
    errorPage2: 0,
    errorPage3: 0,
  });
  const config = {
    rules: [
      { type: "object", required: true, message: t("Message.FieldsRequired") },
    ],
  };

 const [ErrorMessage,setErrorMessage] = useState(false)
 const [enable,setEnable] = useState(false)
 const [enableAddLanguage,setEnableAddLng] = useState(true)


const start =  () => {
  let currentLng  = listLang?.at(-1)?.lang
  let currentLink = listLang?.at(-1)?.link
  if(OpenMenu === true && listLang?.length === 0 ) {
     setErrorMessage(t("Translate.error"));
     setEnable(true);
     setEnableAddLng(false)
  }
  else if (values.isYoutube && !currentLink && !currentLng) {
    setErrorMessage(t("Translate.emptyFields"));
    setEnable(true);
    return;
  }
  
   if (values.isYoutube && !currentLng) {
    setErrorMessage(t("Translate.emptyLanguage"));
    setEnable(true);
    return;
  }
  else {
    setEnable(false)
  }
  if (values.isYoutube && !currentLink) {
    setErrorMessage(t("Translate.emptyInput"));
    setEnable(true);
    return;
  }
  else {
    setEnable(false);
    setEnableAddLng(true)
    setErrorMessage("");
    setLoadingStart(true);
  }
}

const onChangeActiveKey = (activeKey1) => {
    const urlPattern = /^https:\/\/[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/;
  if (activeKey1 === "1") {
    if (
      values.langs === "" ||
      values.stationID === "" ||
      values.title === "" ||
      values.startDate === "" ||
      values.finalHour === ""
    ) {
      setErrorState((prevState) => ({ ...prevState, errorPage1: 1 }));
    } else {
      setErrorState((prevState) => ({ ...prevState, errorPage1: 0 }));
    }
    
  }else if (activeKey1 === "2" ){
    if ( values.url &&  !urlPattern.test(values.url)) {
      setErrorState((prevState) => ({ ...prevState, errorPage2: 2}));
    } 
    else
     if (values.url === "" ){
      setErrorState((prevState) => ({ ...prevState, errorPage2: 0}));
     } 
  }
  else{
    if (values.organizerName === "") {
      setErrorState((prevState) => ({ ...prevState, errorPage3: 3 }));

        }else{
      setErrorState((prevState) => ({ ...prevState, errorPage3: 0 }));
    }
  }
  
    
  setActiveKey(activeKey1);
};
useEffect(()=>{
  const urlPattern = /^https:\/\/[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/;
if(location?.state?.action === "update"){
  if(values.stationID !== "" &&
   values.organizerName !=="" &&
    values.title !== "" &&
    values.langs.length > 0
    ){
    setErrorState((prevState) => ({ ...prevState, errorPage1: 0 })); 
    setErrorState((prevState) => ({ ...prevState, errorPage2: 0}));
    setErrorState((prevState) => ({ ...prevState, errorPage3: 0}));
  }else{
    if(values.organizerName === ""){
      setErrorState((prevState) => ({ ...prevState, errorPage3: 3}));
    }
  }
}else{

  if (
    values.langs === "" ||
    values.stationID === "" ||
    values.title === "" ||
    values.startDate === "" ||
    values.finalHour === ""
  ) {
    setErrorState((prevState) => ({ ...prevState, errorPage1: 1 }));
  } 
  else{
    setErrorState((prevState) => ({ ...prevState, errorPage1: 0 }));
  

  }if (values.url && !urlPattern.test(values.url)) {
    setErrorState((prevState) => ({ ...prevState, errorPage2: 2}));
  }  else if(values.url === "" || urlPattern.test(values.url) ){
    setErrorState((prevState) => ({ ...prevState, errorPage2: 0}));
  }   if (values.organizerName === "") {
    setErrorState((prevState) => ({ ...prevState, errorPage3: 3 }));

  }else{
    setErrorState((prevState) => ({ ...prevState, errorPage3: 0 }));
  }

}
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[values,values?.organizerName,location?.state?.action])
const onFinishFailed = (errorInfo) => {
   setLoadingStart(false);
  const invalidOrganizerEmail = errorInfo?.errorFields?.some(field => field.name[0] === "organizerEmail");
    let newArr = Object.values(errorState).filter((row)=> (row !== "0" && row !== 0 ))
    let lastIndex = newArr.at(0)
    let key= Object.keys(errorState).at(0)
    setErrorState((prevState)=>({...prevState,[key]:0}))
    onChangeActiveKey(invalidOrganizerEmail?"3":lastIndex? lastIndex?.toString() === "0" ? "1" : lastIndex?.toString() : "1");
};
const [image, setImage] = useState(null);
// const [isCropped, setIsCropped] = useState(true);
const isCropped = useSelector((state)=>state.reducer.isCropped)
const cropperRef = useRef(null);
const fileInputRef = useRef(null);

const onChangeImg = (e) => {
  e.preventDefault();
  let files;
  if (e.dataTransfer) {
    files = e.dataTransfer?.files;
  } else if (e.target) {
    files = e.target?.files;
  }
  const reader = new FileReader();
  reader.onload = () => {
    setImage(reader.result);
    // setIsCropped(false);
    dispatch({type:"SET-CROPPED",payload:false})
  };
  reader.readAsDataURL(files[0]);
};

const updateImage = () => {
  if (fileInputRef?.current) {
    // Trigger the click event of the file input to open the file dialog
    fileInputRef.current.click();
  } 
};

const handleFileInputChange = (e) => {
  dispatch({type:"UPLOAD_LOGO_URL",payload:URL.createObjectURL(e.target.files[0])})
  if (e.target.files && e.target.files.length > 0) {
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
      // setIsCropped(false); // Reset cropped state when a new image is selected
      dispatch({type:"SET-CROPPED",payload:false})
    };
    reader.readAsDataURL(e.target.files[0]);
  }
};

useEffect(()=>{
  if(values?.isYoutube) {setOpenMenu(true)}
  else {setOpenMenu(false)
    setListLang([])}
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[OpenMenu,values?.isYoutube])

const filterOption = (inputValue, option) => {
    if(option?.label){
      return option?.label?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
    }else{
      return option?.children[0]?.props?.children?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
    }
  };

useEffect(() => {
  if (values?.VideoPortIndex !== undefined ) {
    form.setFieldsValue({
      VideoPortIndex: values.VideoPortIndex,
      AudioPortIndex : values.AudioPortIndex
    });
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [values?.VideoPortIndex,  values?.AudioPortIndex]);
  return (
    <div>
      <Card loading={false}>
        <Spin className="Spin" spinning={!formWait}>
          <Row>
            <Col style={{ width: "100%" }}>
              <Form
                form={form}
                name="product-form"
                initialValues={{
    VideoPortIndex: values?.VideoPortIndex ?? initialState?.VideoPortIndex
  }}
                onSubmit={(e) => e.preventDefault()}
                scrollToFirstError
                onFinishFailed={onFinishFailed}
                onFinish={(e) => {
                                    (values.isSecuredOnInternet
                    ? isValidPassword(values?.passwordInternet)
                    : true) &&
                  !Array.from(Object.values(errorState), (row) => row).filter(
                    (row) => (row !== 0 && row!=="0")
                  )?.length
                    ? onSubmit()
                    : onFinishFailed();
                }}
              >
                <Row className="emp">
                  <Col className="emp-col emp-col_title">
                    <ArrowLeftOutlined
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        history.goBack();
                        window.parent.postMessage(
                          {
                            info: "event",
                            value:  currentStatus === "live" ? 'ongoing':currentStatus ,
                          },
                          "*"
                        );
                      }}
                    />
                    {location.state && location.state.action === "create" ? (
                      <span className="title">
                        {t("Translate.Ajouter un évènement")}
                      </span>
                    ) : (location.state &&
                        location.state.action === "update") ||
                      action === "update" ? (
                      <span className="title">
                        {t("Translate.ModifyAnEvent")}
                      </span>
                    ) : (
                      action === "create" && (
                        <span className="title">
                          {t("Translate.Ajouter un évènement")}
                        </span>
                      )
                    )}
                  </Col>
                  <Col className="emp-col emp-col_buttons">
                    <Button
                      type="default"
                      style={{ marginRight: "15px" }}
                      onClick={() => {
                        history.goBack();
                        window.parent.postMessage(
                          {
                            info: "event",
                            value:  currentStatus === "live" ? 'ongoing':currentStatus ,
                          },
                          "*"
                        );
                      }}
                    >
                      {t("Translate.Annuler")}
                    </Button>
                    <Button
                      onClick={start}
                      loading={loadingStart}
                      type="primary"
                      htmlType="submit"
                      disabled={enable || (values?.isYoutube && (enable || !(listLang?.at(-1)?.link) || !(listLang?.at(-1)?.lang)))}
                    >
                      {t("Translate.Valider")}
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ width: "100%" }}>
                    <Tabs
                      activeKey={activeKey}
                      className={"tabs-content"}
                      onChange={(activeKey) => onChangeActiveKey(activeKey)}
                    >
                      <TabPane tab={t("Translate.Formulaire")} key="1">
                        <div className="row-tabPane">
                          <div
                            className="bloc-form"
                            style={{ textAlign: "left" }}
                          >
                            <div className="input-form">
                              <span className="label">
                                {t("Translate.Langues")}
                                <span className="require">*</span>
                              </span>
                              <Form.Item
                                name="langs"
                                rules={requiredFieldRule}
                                style={{ textAlign: "left" }}
                                className="FormItemCheckbox"
                              >
                                <Select
                                  name="langs"
                                  mode="multiple"
                                  style={{ width: "100%" }}
                                  placeholder="Select languages"
                                  onChange={handleChangeLang}
                                  value={selectedValues}
                                >
                                  {dataLang.map((item) => (
                                    <Option key={item.value} value={item.value}>
                                      {item.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                            {/* Country Select */}
                           {event_module?.countries_event_action?.authorized && <div className="input-form">
                              <span className="label">
                                {t("Translate.Country")}
                              </span>
                              <Form.Item
                                name="countries"
                                style={{ textAlign: "left" }}
                                className="FormItemCheckbox"
                              >
                                <Select
                                  name="countries"
                                  mode="multiple"
                                  showSearch
                                  style={{ width: "100%" }}
                                  placeholder={t("Translate.select_countries")}
                                  onChange={(name, action) => {
                                    setSelectedCountry(name)
                                    handleCountriesSelect(name, action);
                                  }}
                                  value={selectedCountry}
                                  optionFilterProp="children"
                                >
                                  {countries?.map((item) => (
                                    <Option key={item.id} name="countries" value={item.id}>
                                      {item.country_name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>}
                           {/* Station select  */}

                            <div className="input-form">
                              <span className="label">
                                {t("Translate.station")}
                                <span className="require">*</span>
                              </span>
                              <Form.Item name="stationID">
                                <Select
                                  name="stationID"
                                  placeholder={t("AddEvent.SelectYourEncoder")}
                                  onChange={(name, action) => {
                                    onChange_select("stationID", name, action);
                                  }}
                                  initialValues={initialState?.stationName}
                                >
                                  {!loading &&
                                    GetINFO.getInfoForm.stations.map(
                                      (station) => {
                                        return (
                                          <Option
                                            value={station.id}
                                            name="stationID"
                                            key={station.id}
                                          >
                                            {station.name}
                                          </Option>
                                        );
                                      }
                                    )}
                                </Select>
                              </Form.Item>
                            </div>
                            <div className="input-form">
                              <span className="label">
                                {t("Translate.Direction")}
                              </span>
                               <Form.Item name="themeIds">
               <Select
                 showSearch
                 mode="multiple"
                 style={{ width: "100%" }}
                 onChange={(name, action) => { 
                    onChange_select("themeIds", name, action);
                 }}      
                 name="Direction"
                 initialValue={initialState?.themeIds}
                 filterOption={filterOption}
               >
                 {optionThemes?.map((canal,index) => (
                   <Select.OptGroup name="themeIds" key={`${canal.id}`} label={canal.title} style={{fontWeight:"800"}}>
                     {canal.themes?.map((theme) => (
                       <Select.Option name="themeIds" key={`${canal.id}-${theme.id}-${index}`} value={theme.id} className={theme.child ? 'select-themes' : ''} style={{ marginLeft: theme.pos * 20 + 'px'}}>
                         {theme?.parent && (
                           <span style={{ marginLeft: theme.pos * 20 + 'px' }}>
                             {theme?.title}
                           </span>
                         )}
                         {theme?.child && (
                           <span>&nbsp;&nbsp;&nbsp;&nbsp;{theme?.title}</span>
                         )}
                       </Select.Option>
                     ))}
                   </Select.OptGroup>
                 ))}
               </Select>
             </Form.Item>

                              {/* <Form.Item name="themeId">
                                <Select
                                  placeholder="Direction"
                                  onChange={(name, action) => {
                                    onChange_select("themeId", name, action);
                                  }}
                                  name="Direction"
                                  initialValues={initialState?.themeName}
                                >
                                  {!loading &&
                                    GetINFO.getInfoForm.themes.map((theme) => {
                                      return (
                                        <Option
                                          value={theme.id}
                                          name="themeId"
                                          key={theme.id}
                                        >
                                          {theme.title}
                                        </Option>
                                      );
                                    })}
                                </Select>
                              </Form.Item> */}
                            </div>
                            <div className="input-form">
                              <span className="label">
                                {t("Translate.Titre")}
                                <span className="require">*</span>
                              </span>
                              <Form.Item name="title" rules={requiredFieldRule}>
                                <Input
                                  onChange={onChange}
                                  name="title"
                                  placeholder={t("Translate.Ajouter un titre")}
                                  initialValues={initialState?.title}
                                />
                              </Form.Item>
                            </div>
                            <div className="input-form">
                              <span className="label">Description</span>
                              <Form.Item name="description">
                                <Input.TextArea
                                  style={{ width: "100%", height: "100%" }}
                                  onChange={onChange}
                                  rows="4"
                                  placeholder={t(
                                    "Translate.Ajouter une description"
                                  )}
                                  name="description"
                                  initialValues={initialState?.description}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          <div className="bloc-form bloc-form-div">
                            <Row>
                              <span className="label">
                                {t("Translate.Date de début")}
                                <span className="require">*</span>
                              </span>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Form.Item
                                  name="startDate"
                                  {...config}
                                  style={{ textAlign: "left" }}
                                >
                                  <DatePicker
                                    className="input-form"
                                    onChange={onChange_datePicker}
                                    name="startDate"
                                    format={"YYYY-MM-DD"}
                                    initialValues={
                                      initialState?.startDate &&
                                      moment(
                                        initialState?.startDate,
                                        "YYYY-MM-DD"
                                      )
                                    }
                                    disabledDate={disablePastDate}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row className="row_timepicker row_timepicker_title">
                              <Col span={6} className="timepicker">
                                <span className="label">
                                  {t("Translate.Heure de début")}
                                  <span className="require">*</span>
                                </span>
                              </Col>

                              <Col span={6} className="timepicker">
                                <span className="label">
                                  {t("Translate.Heure de fin")}
                                  <span className="require">*</span>
                                </span>
                              </Col>
                            </Row>
                            <Row className="row_timepicker time">
                              <Col span={6} className="timepicker">
                                <Form.Item
                                  name="startHour"
                                  rules={[
                                    {
                                      type: "object",
                                      required: true,
                                      message: t("Message.FieldsRequired"),
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        if (
                                          isValideTempStart(
                                            values.startHour,
                                            values.finalHour
                                          )
                                        ) {
                                          return Promise.resolve("value");
                                        }
                                        return Promise.reject(
                                          t("AddEvent.ChooseSuitableStartTime")
                                        );
                                      },
                                    }),
                                  ]}
                                >
                                  <TimePicker
                                    className="date_debut"
                                    disabled={eventStatus===0}
                                    onChange={onChange_dateTime_debut}
                                    placeholder="HH:mm"
                                    name="startHour"
                                    initialValues={
                                      initialState?.startHour &&
                                      moment(initialState?.startHour, "HH:mm")
                                    }
                                    disabledHours={() =>
                                      startGetDisabledHours(values.finalHour)
                                    }
                                    disabledMinutes={startGetDisabledMinutes}
                                    format={"HH:mm"}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={6} className="timepicker">
                                <Form.Item
                                  name="finalHour"
                                  rules={[
                                    {
                                      type: "object",
                                      required: true,
                                      message: t("Message.FieldsRequired"),
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        if (
                                          isValideTempFinal(
                                            values.startHour,
                                            values.finalHour
                                          )
                                        ) {
                                          return Promise.resolve("value");
                                        }
                                        return Promise.reject(
                                          t("AddEvent.ChooseSuitableEndTime")
                                        );
                                      },
                                    }),
                                  ]}
                                >
                                  <TimePicker
                                    className="date_fin"
                                    onChange={onChange_dateTime_fin}
                                    placeholder="HH:mm"
                                    name="finalHour"
                                    initialValues={
                                      initialState?.finalHour &&
                                      moment(initialState?.finalHour, "HH:mm")
                                    }
                                    disabledHours={() =>
                                      FinalGetDisabledHours(values.startHour)
                                    }
                                    disabledMinutes={finalGetDisabledMinutes}
                                    format={"HH:mm"}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={6} className="btn_stop">
                                {location.state &&
                                location.state.action ===
                                  "create" ? null : location.state &&
                                  location.state.action === "update" ? (
                                  (location.state &&
                                    location.state.initialTypeEvent ===
                                      "live") ||
                                  initialTypeEvent === "live" ? (
                                    <Button
                                      onClick={StopEvent}
                                      type="primary"
                                      className="btn_stop"
                                    >
                                      {t("AddEvent.Stop")}
                                    </Button>
                                  ) : (location.state &&
                                      location.state.initialTypeEvent ===
                                        "upcoming") ||
                                    initialTypeEvent ===
                                      "upcoming" ? null : null
                                ) : null}
                              </Col>
                            </Row>
                            <Form.Item
                              name="videoDisplay"
                              style={{
                                textAlign: "left",
                              }}
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (isValidVideo(value)) {
                                      return Promise.resolve("value");
                                    }
                                    return Promise.reject(
                                      t("AddEvent.BroadcastOpt")
                                    );
                                  },
                                }),
                              ]}
                            >
                              <Checkbox.Group name="videoDisplay">
                                <Row>
                                  <Col span={24} className="checkbox">
                                    <Row
                                      className="row_infos"
                                      justify="space-between"
                                      style={{ width: "100%" }}
                                    >
                                      <Col span={12}>
                                        <Col
                                          span={24}
                                          style={{ marginBottom: "1.2em" }}
                                        >
                                          <Checkbox
                                            onChange={onChange_checkbox}
                                            name="vodRecord"
                                            value="vodRecord"
                                            style={{
                                              lineHeight: "32px",
                                            }}
                                            defaultChecked={
                                              initialState?.vodRecord
                                            }
                                          />
                                          <span
                                            className="label"
                                            style={{ marginLeft: "3%" }}
                                          >
                                            {t(
                                              "Translate.VOD en ligne après le direct"
                                            )}
                                          </span>
                                        </Col>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col
                                        span={12}
                                        style={{ marginBottom: "1.5em" }}
                                      >
                                        <Checkbox
                                          onChange={onChange_checkbox}
                                          name="downloadable"
                                          value="downloadable"
                                          style={{
                                            lineHeight: "32px",
                                          }}
                                          defaultChecked={
                                            initialState?.downloadable
                                          }
                                        >
                                          <span className="label">
                                            {t(
                                              "Translate.Vidéo téléchargeable"
                                            )}
                                          </span>
                                        </Checkbox>
                                      </Col>
                                      <Col span={12}>
                                        <Checkbox
                                          onChange={onChange_checkbox}
                                          name="isDvr"
                                          value="isDvr"
                                          style={{
                                            lineHeight: "32px",
                                          }}
                                          defaultChecked={initialState?.isDvr}
                                        >
                                          <span className="label">
                                            DVR
                                            {/* {t("Translate.Diffusion auto")} */}
                                          </span>
                                        </Checkbox>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col
                                        span={24}
                                        style={{
                                          marginBottom:
                                            values.isVisibleOnInternet
                                              ? "0.75em"
                                              : "1.2em",
                                        }}
                                      >
                                        <Checkbox
                                          onChange={onChange_checkbox}
                                          name="isVisibleOnInternet"
                                          value="isVisibleOnInternet"
                                          style={{
                                            lineHeight: "32px",
                                          }}
                                          // defaultChecked={
                                          //   initialState.isVisibleOnInternet
                                          // }
                                          checked={
                                            initialState?.isVisibleOnInternet
                                          }
                                        >
                                          <span className="label">
                                            {t("Translate.Diffusion internet")}
                                          </span>
                                        </Checkbox>
                                      </Col>
                                    </Row>
                                    {values.isVisibleOnInternet && (
                                      <Row className="all">
                                        <Col
                                          span={24}
                                          style={{
                                            left: "8%",
                                            width: "100%",
                                            marginBottom:
                                              values.isVisibleOnInternet
                                                ? "0.5em"
                                                : "1em",
                                          }}
                                        >
                                          <Checkbox
                                            onChange={onChange_checkbox}
                                            name="isSecuredOnInternet"
                                            value="isSecuredOnInternet"
                                            style={{
                                              lineHeight: "32px",
                                            }}
                                            defaultChecked={
                                              initialState?.isSecuredOnInternet
                                            }
                                          >
                                            <span className="label">
                                              {t(
                                                "Translate.Internet_secured_by_password"
                                              )}
                                            </span>
                                          </Checkbox>
                                        </Col>
                                      </Row>
                                    )}
                                    {values.isVisibleOnInternet &&
                                    values.isSecuredOnInternet ? (
                                      <Row style={{ width: "100%" }}>
                                        <Col
                                          className={"col-Password_Internet"}
                                          span={24}
                                          style={{
                                            marginBottom: "1em",
                                          }}
                                        >
                                          <Input.Password
                                            name="passwordInternet"
                                            onChange={onChange}
                                            style={{ width: "91%" }}
                                            value={values.passwordInternet}
                                            className={
                                              !isValidPassword(
                                                values?.passwordInternet
                                              )
                                                ? "error"
                                                : ""
                                            }
                                          />
                                          <div
                                            style={{
                                              width: "91%",
                                              color: "#ff4d4f",
                                              fontSize: "12px",
                                            }}
                                            className={
                                              values?.passwordInternet
                                                ? "hidden-error"
                                                : ""
                                            }
                                          >
                                            {t("AddEvent.EnterPassword")}
                                          </div>
                                          <div
                                            style={{
                                              width: "91%",
                                              color: "#ff4d4f",
                                              fontSize: "12px",
                                            }}
                                            className={
                                              isValidPassword(
                                                values?.passwordInternet
                                              )
                                                ? "hidden-error"
                                                : ""
                                            }
                                          >
                                            {t("AddEvent.MinimumOfChar")}
                                          </div>
                                        </Col>
                                      </Row>
                                    ) : null}
                                    {isAutoStation?
                                           <Row>
                                           <Col span={24}>
                                             <Checkbox
                                               onChange={onChange_checkbox}
                                               name="isAuto"
                                               value="isAuto"
                                               style={{
                                                 lineHeight: "32px",
                                               }}
                                               defaultChecked={initialState?.isAuto}
                                             >
                                               <span className="label">
                                                 {t("Translate.Diffusion auto")}
                                               </span>
                                             </Checkbox>
                                           </Col>
                                         </Row>
                                    :null

                                    }
                                    {values.isAuto && isAutoStation ?        <Row gutter={16}>
  <Col span={12}>
    <Form.Item name="VideoPortIndex" label={t("Translate.VideoPortIndex")}>
      <InputNumber
        min={0}
        max={3}
        onChange={(value) => onChange_Number("VideoPortIndex", value)}
        readOnly={isSDIstation}
        style={{ width: "100%" }}
      />
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="AudioPortIndex" label={t("Translate.AudioPortIndex")}>
      <InputNumber
        min={0}
        max={3}
        onChange={(value) => onChange_Number("AudioPortIndex", value)}
        defaultValue={initialState?.AudioPortIndex}
        style={{ width: "100%" }}
      />
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="ProtocolType" label={t("Translate.ProtocolType")}>
      <Select
        onChange={(value,action) => onChange_select("ProtocolType", value,action)}
        defaultValue="srt"
        style={{ width: "100%" }}
      >
        <Select.Option value="srt">SRT</Select.Option>
      </Select>
    </Form.Item>
  </Col>
</Row>
:null}
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    gridGap: "5px",
                                  }}
                                >
                                  <Col span={24}>
                                    <Checkbox
                                      onClick={() => {
                                        setOpenMenu(!OpenMenu);
                                        if (listLang?.length === 0) {
                                          setEnable(false);
                                          setErrorMessage("");
                                        }
                                      }}
                                      onChange={onChange_checkbox}
                                      name="isYoutube"
                                      value="isYoutube"
                                      style={{
                                        lineHeight: "32px",
                                      }}
                                      defaultChecked={initialState?.isYoutube}
                                    >
                                      <span className="label">
                                        {t("Translate.Youtube")}
                                      </span>
                                    </Checkbox>
                                  </Col>
                                  {OpenMenu &&
                                    listLang?.map((lang, index) => (
                                      <Col
                                        key={index}
                                        span={24}
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          marginTop: "8px",
                                          marginLeft: "1px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-input"
                                          style={{
                                            marginLeft: "30px",
                                            marginTop: "10px",
                                          }}
                                          checked
                                          onClick={() => {
                                            setListLang((prevList) => {
                                              const updatedList =
                                                prevList.filter(
                                                  (el, i) => i !== index
                                                );
                                              return updatedList;
                                            });
                                          }}
                                        />
                                        <Select
                                          value={lang.lang}
                                          style={{
                                            width: "59px",
                                            maxWidth: "59px",
                                            minWidth: "59px",
                                          }}
                                          className="here"
                                          onChange={(e) => {
                                            setListLang((prevListLang) =>
                                              prevListLang.map((item, i) =>
                                                i === index
                                                  ? {
                                                      ...item,
                                                      lang: e,
                                                    }
                                                  : item
                                              )
                                            );
                                            setEditLanguage(e);
                                          }}
                                          options={options}
                                        />
                                        <span
                                          style={{
                                            position: "relative",
                                            width: "100%",
                                          }}
                                        >
                                          <div style={{ position: "relative", width: "100%" }}>
                                          <svg
                                            className={`copy-icon ${
                                              isEnabled ? "disabled" : ""
                                            }`}
                                            style={{
                                              position: "absolute",
                                              top: "7px",
                                              right: "5px",
                                              zIndex: "9",
                                              cursor: "pointer",
                                            }}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="18"
                                            viewBox="0 0 16 18"
                                            fill="none"
                                            onClick={(e) => {
                                              handleCopyClick(
                                                `Youtuberl_${index}`,
                                                index,
                                                e
                                              );
                                            }}
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M10.4615 0H7.13354C5.62544 0 4.43077 0 3.49621 0.128093C2.53456 0.260372 1.7559 0.538326 1.14133 1.16456C0.52759 1.79163 0.25518 2.58614 0.125539 3.56735C9.78128e-08 4.52177 0 5.73991 0 7.2787V12.3488C1.98066e-05 13.0968 0.261691 13.8202 0.737918 14.3889C1.21414 14.9575 1.87365 15.334 2.59774 15.4507C2.71015 16.0903 2.92759 16.6362 3.36246 17.0807C3.85641 17.5847 4.47836 17.8007 5.21682 17.9029C5.92821 18 6.83323 18 7.95487 18H10.5067C11.6283 18 12.5333 18 13.2447 17.9029C13.9832 17.8007 14.6051 17.5847 15.0991 17.0807C15.593 16.5767 15.8047 15.9421 15.9048 15.1887C16 14.4628 16 13.5393 16 12.3949V8.11674C16 6.97228 16 6.04884 15.9048 5.32298C15.8047 4.56949 15.593 3.93488 15.0991 3.43088C14.6634 2.98716 14.1284 2.7653 13.5015 2.6506C13.3872 1.91178 13.0182 1.23885 12.4609 0.752934C11.9036 0.267016 11.1946 2.02096e-05 10.4615 0ZM12.2092 2.52921C12.0845 2.15749 11.8489 1.83488 11.5355 1.60654C11.2221 1.37821 10.8466 1.25557 10.4615 1.25581H7.17949C5.61477 1.25581 4.5038 1.25749 3.65949 1.37302C2.83487 1.48605 2.35897 1.6987 2.0119 2.05284C1.66482 2.40698 1.45641 2.89256 1.34564 3.73479C1.23241 4.59544 1.23077 5.72902 1.23077 7.32558V12.3488C1.23053 12.7418 1.35072 13.1249 1.5745 13.4447C1.79828 13.7644 2.11446 14.0048 2.47877 14.1321C2.46154 13.6214 2.46154 13.0437 2.46154 12.3949V8.11674C2.46154 6.97228 2.46154 6.04884 2.55754 5.32298C2.656 4.56949 2.86933 3.93488 3.36246 3.43088C3.85641 2.92688 4.47836 2.71088 5.21682 2.60958C5.92821 2.51163 6.83323 2.51163 7.95487 2.51163H10.5067C11.1426 2.51163 11.7087 2.51163 12.2092 2.52921ZM4.23221 4.32C4.45949 4.08809 4.77785 3.9374 5.38092 3.85451C5.99959 3.76995 6.82174 3.76828 7.99918 3.76828H10.4607C11.6382 3.76828 12.4595 3.76995 13.0798 3.85451C13.6821 3.9374 14.0004 4.08893 14.2277 4.32C14.455 4.55191 14.6027 4.87674 14.6839 5.49209C14.7668 6.12335 14.7684 6.96223 14.7684 8.16363V12.3497C14.7684 13.5511 14.7668 14.3891 14.6839 15.022C14.6027 15.6366 14.4542 15.9614 14.2277 16.1933C14.0004 16.4252 13.6821 16.5759 13.079 16.6588C12.4595 16.7433 11.6382 16.745 10.4607 16.745H7.99918C6.82174 16.745 5.99959 16.7433 5.3801 16.6588C4.77785 16.5759 4.45949 16.4244 4.23221 16.1933C4.00492 15.9614 3.85723 15.6366 3.776 15.0212C3.69313 14.3891 3.69149 13.5511 3.69149 12.3497V8.16363C3.69149 6.96223 3.69313 6.12335 3.776 5.49126C3.85723 4.87674 4.00574 4.55191 4.23221 4.32Z"
                                              fill="#6B6B89"
                                            />
                                          </svg>
                                          <div>
                                          <input
                                            name="urlYoutube"
                                            defaultValue={lang.link}
                                            type="text"
                                            id={`Youtuberl_${index}`}
                                            className="ant-input"
                                            style={{paddingRight:"25px"}}
                                            onChange={(e) =>
                                            {                                              
                                              handleEditYoutubeLinks(e, index)
                                            }
                                            }
                                          />
                                          </div>
                                        </div>
                                        </span>
                                      </Col>
                                    ))}
                                  {OpenMenu && listLang?.length < 7 && (
                                    <>
                                      <Col
                                        span={24}
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          marginTop: "8px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-input"
                                          style={{
                                            marginLeft: "28px",
                                            marginTop: "5px",
                                          }}
                                          onChange={handleCheckboxChange}
                                          name="lang"
                                          value="lang"
                                          checked={isEnabled}
                                          defaultChecked={isEnabled}
                                        />
                                        <Select
                                          defaultValue=""
                                          style={{
                                            width: "60px",
                                            maxWidth: "60px",
                                            minWidth: "60px",
                                          }}
                                          dropdownStyle={{
                                            width: "60px",
                                            maxWidth: "60px",
                                            minWidth: "60px",
                                          }}
                                          className="here"
                                          onChange={(value) =>
                                            {
                                              setLanguageUrl(value);
                                              setEnable(false);
                                              setErrorMessage("");
                                            }
                                          }
                                          value={languageUrl}
                                          options={options}
                                          disabled={!isEnabled}
                                        />
                                        <span
                                          style={{
                                            position: "relative",
                                            width: "100%",
                                          }}
                                        >
                                          <div style={{ position: "relative", width: "100%" }}>
                                          <svg
                                            className={`copy-icon ${
                                              !isEnabled || !OpenMenu
                                                ? "disabled"
                                                : ""
                                            }`}
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              right: "5px",
                                              transform: "translateY(-50%)",
                                              zIndex: "9",
                                              cursor: "pointer",
                                            }}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="18"
                                            viewBox="0 0 16 18"
                                            fill="none"
                                            onClick={(e) => {
                                              handleCopyClick(
                                                `OtherInput`,
                                                listLang?.length,
                                                e
                                              );
                                            }}
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M10.4615 0H7.13354C5.62544 0 4.43077 0 3.49621 0.128093C2.53456 0.260372 1.7559 0.538326 1.14133 1.16456C0.52759 1.79163 0.25518 2.58614 0.125539 3.56735C9.78128e-08 4.52177 0 5.73991 0 7.2787V12.3488C1.98066e-05 13.0968 0.261691 13.8202 0.737918 14.3889C1.21414 14.9575 1.87365 15.334 2.59774 15.4507C2.71015 16.0903 2.92759 16.6362 3.36246 17.0807C3.85641 17.5847 4.47836 17.8007 5.21682 17.9029C5.92821 18 6.83323 18 7.95487 18H10.5067C11.6283 18 12.5333 18 13.2447 17.9029C13.9832 17.8007 14.6051 17.5847 15.0991 17.0807C15.593 16.5767 15.8047 15.9421 15.9048 15.1887C16 14.4628 16 13.5393 16 12.3949V8.11674C16 6.97228 16 6.04884 15.9048 5.32298C15.8047 4.56949 15.593 3.93488 15.0991 3.43088C14.6634 2.98716 14.1284 2.7653 13.5015 2.6506C13.3872 1.91178 13.0182 1.23885 12.4609 0.752934C11.9036 0.267016 11.1946 2.02096e-05 10.4615 0ZM12.2092 2.52921C12.0845 2.15749 11.8489 1.83488 11.5355 1.60654C11.2221 1.37821 10.8466 1.25557 10.4615 1.25581H7.17949C5.61477 1.25581 4.5038 1.25749 3.65949 1.37302C2.83487 1.48605 2.35897 1.6987 2.0119 2.05284C1.66482 2.40698 1.45641 2.89256 1.34564 3.73479C1.23241 4.59544 1.23077 5.72902 1.23077 7.32558V12.3488C1.23053 12.7418 1.35072 13.1249 1.5745 13.4447C1.79828 13.7644 2.11446 14.0048 2.47877 14.1321C2.46154 13.6214 2.46154 13.0437 2.46154 12.3949V8.11674C2.46154 6.97228 2.46154 6.04884 2.55754 5.32298C2.656 4.56949 2.86933 3.93488 3.36246 3.43088C3.85641 2.92688 4.47836 2.71088 5.21682 2.60958C5.92821 2.51163 6.83323 2.51163 7.95487 2.51163H10.5067C11.1426 2.51163 11.7087 2.51163 12.2092 2.52921ZM4.23221 4.32C4.45949 4.08809 4.77785 3.9374 5.38092 3.85451C5.99959 3.76995 6.82174 3.76828 7.99918 3.76828H10.4607C11.6382 3.76828 12.4595 3.76995 13.0798 3.85451C13.6821 3.9374 14.0004 4.08893 14.2277 4.32C14.455 4.55191 14.6027 4.87674 14.6839 5.49209C14.7668 6.12335 14.7684 6.96223 14.7684 8.16363V12.3497C14.7684 13.5511 14.7668 14.3891 14.6839 15.022C14.6027 15.6366 14.4542 15.9614 14.2277 16.1933C14.0004 16.4252 13.6821 16.5759 13.079 16.6588C12.4595 16.7433 11.6382 16.745 10.4607 16.745H7.99918C6.82174 16.745 5.99959 16.7433 5.3801 16.6588C4.77785 16.5759 4.45949 16.4244 4.23221 16.1933C4.00492 15.9614 3.85723 15.6366 3.776 15.0212C3.69313 14.3891 3.69149 13.5511 3.69149 12.3497V8.16363C3.69149 6.96223 3.69313 6.12335 3.776 5.49126C3.85723 4.87674 4.00574 4.55191 4.23221 4.32Z"
                                              fill="#6B6B89"
                                            />
                                          </svg>
                                          <div>
                                            <input
                                              name="urlYoutube"
                                              initialvalues=""
                                              type="text"
                                              id={`OtherInput`}
                                              className="ant-input"
                                              disabled={!isEnabled}
                                              style={{ paddingRight: "25px" }} 
                                              onChange={(e) =>
                                              {  handleInputYoutubeChange(e)}
                                               }
                                              value={inputYoutube}
                                            />
                                          </div>
                                          </div>
                                        </span>
                                      </Col>
                                      <span className="errorUrl">
                                        {errorUrl
                                          ? t("Translate.validUrl")
                                          : ""}
                                      </span>
                                    </>
                                  )}
                                </Row>
                                <Row style={{ textAlign: "center" }}>
                                  <Col span={24}>
                                    {(OpenMenu && listLang?.length < 7) && (
                                      <Button
                                        placeholder="here"
                                        style={{
                                          margin: "10px auto",
                                          flexShrink: "0",
                                          borderRadius: "5px",
                                        }}
                                        disabled={errorUrl || (enable && enableAddLanguage)}
                                        onClick={handleAjouter}
                                      >
                                        {t("Translate.Language")}
                                      </Button>
                                    )}
                                    <div>
                                      {duplicateError && (
                                        <p style={{ color: "red" }}>
                                          {duplicateError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      {ErrorMessage && (
                                        <p style={{ color: "red" }}>
                                          {ErrorMessage}
                                        </p>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </Form.Item>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane
                        tab={t("Translate.Informations supplémentaires")}
                        key="2"
                      >
                                                <div className="row-tabPane" style={{'gap':"1.5em"}}>

                        <div className="colTabPane">
                          <div className="input-form">
                            <span className="label">
                              {" "}
                              {t("Translate.Vignette")}
                            </span>
                            <Form.Item name="fileList">
                              <div style={{ width: "100%" }}>
                                <input
                                  type="file"
                                  onChange={onChangeImg}
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  accept="image/*"
                                />
                                <div
                                  className="imageSelect"
                                  style={{ position: "relative" }}
                                >
                                  <MoreOutlined
                                    onClick={handleOpenMenu}
                                    className={`${
                                      loader ? "noMoreBtn" : "moreBtnMenu"
                                    }`}
                                  />
                                  {!isCropped ? (
                                    <>
                                      <Cropper
                                        style={{
                                          height: "100%",
                                          width: "100%",
                                          objectFit: "cover",
                                        }}
                                        preview=".img-preview"
                                        src={
                                          uploadLogoUrl
                                            ? uploadLogoUrl
                                            : initialState?.logoUrl
                                        }
                                        ref={cropperRef}
                                        name="fileList"
                                        listType="picture"
                                        accept={acceptString}
                                        fileList={fileList}
                                        viewMode={1}
                                        guides={true}
                                        minCropBoxHeight={10}
                                        minCropBoxWidth={10}
                                        aspectRatio={16 / 9}
                                        background={false}
                                        responsive={true}
                                        checkOrientation={false}
                                        onInitialized={(instance) => {
                                          handleCloseMenu();
                                          setCropper(instance);
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      {uploadLogoUrl ||
                                      initialState?.logoUrl ? (
                                        <>
                                          <Spin
                                            spinning={loader}
                                            indicator={
                                              <LoadingOutlined
                                                style={{ fontSize: 24 }}
                                                spin
                                              />
                                            }
                                          >
                                            <img
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "2px solid #d9d9d9",
                                              }}
                                              src={
                                                uploadLogoUrl
                                                  ? uploadLogoUrl
                                                  : initialState?.logoUrl
                                              }
                                              loading="lazy"
                                              alt="cropped"
                                              onLoad={() => {
                                                dispatch({
                                                  type: "SET-LOADER",
                                                  payload: false,
                                                });
                                              }}
                                            />
                                          </Spin>
                                        </>
                                      ) : (
                                        <>
                                          <div className="uploadDiv">
                                            <Spin
                                              spinning={loader}
                                              indicator={
                                                <LoadingOutlined
                                                  style={{ fontSize: 24 }}
                                                  spin
                                                />
                                              }
                                            >
                                              <img
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  border: "2px solid #d9d9d9",
                                                }}
                                                src="/noEventImg.webp"
                                                alt="noImg"
                                                className="noImgAvailable"
                                                loading="lazy"
                                                onLoad={() => {
                                                  dispatch({
                                                    type: "SET-LOADER",
                                                    payload: false,
                                                  });
                                                }}
                                              />
                                            </Spin>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                              <div>
                                <div
                                  className="box"
                                  style={{ width: "50%", float: "right" }}
                                >
                                  <h1>
                                    {!isCropped && (
                                      <Button
                                        style={{
                                          float: "right",
                                          fontSize: "12px",
                                        }}
                                        onClick={(e) => {
                                          getCropData(e);
                                          dispatch({
                                            type: "SET-CROPPED",
                                            payload: true,
                                          });
                                        }}
                                      >
                                        {t("Translate.Confirm")}
                                      </Button>
                                    )}
                                  </h1>
                                </div>
                              </div>
                              <br style={{ clear: "both" }} />
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">Copyright</span>
                            <Form.Item name="copyright">
                              <Input
                                onChange={onChange}
                                name="copyright"
                                placeholder={t("Translate.Ajouter Copyright")}
                                initialValues={initialState?.copyright}
                              />
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">
                              {" "}
                              {t("Translate.Mots clés")}
                            </span>
                            <Card size="small">
                              {tags?.length
                                ? tags?.map((tag, index) => {
                                    if (editInputIndex === index) {
                                      return (
                                        <Input
                                          ref={editInputRef}
                                          key={tag}
                                          size="small"
                                          className="tag-input"
                                          value={editInputValue}
                                          onChange={handleEditInputChange}
                                          onBlur={handleEditInputConfirm}
                                          onPressEnter={handleEditInputConfirm}
                                        />
                                      );
                                    }
                                    const isLongTag = tag?.length > 20;
                                    const tagElem = (
                                      <Tag
                                        className="edit-tag"
                                        key={tag}
                                        closable={true}
                                        onClose={() => handleClose(tag)}
                                      >
                                        <span
                                          onDoubleClick={(e) => {
                                            if (index !== 0) {
                                              setEditInputIndex(index);
                                              setEditInputValue(tag);
                                              e.preventDefault();
                                            }
                                          }}
                                        >
                                          {isLongTag
                                            ? `${tag.slice(0, 20)}...`
                                            : tag}
                                        </span>
                                      </Tag>
                                    );
                                    return isLongTag ? (
                                      <Tooltip title={tag} key={tag}>
                                        {tagElem}
                                      </Tooltip>
                                    ) : (
                                      tagElem
                                    );
                                  })
                                : null}
                              {inputVisible && (
                                <Form>
                                  <Form.Item
                                    name="keyword"
                                    rules={[
                                      {
                                        validator: (_, value) => {
                                          if ( tags &&
                                            tags.some((tag) =>
                                            tag === value
                                            )
                                          ) {
                                            return Promise.reject(
                                              new Error(
                                                t("Message.InvalidKeyword")
                                              )
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      },
                                    ]}
                                  >
                                    <Input
                                      id="video-input"
                                      ref={inputRef}
                                      type="text"
                                      size="small"
                                      className="tag-input"
                                      value={inputValue}
                                      onChange={handleInputChange}
                                      onBlur={handleInputConfirm}
                                      onPressEnter={handleInputConfirm}
                                    />
                                  </Form.Item>
                                </Form>
                              )}
                              {!inputVisible && (
                                <Tag
                                  className="site-tag-plus"
                                  onClick={showInput}
                                >
                                  <PlusOutlined /> {t("Translate.Mots clés")}
                                </Tag>
                              )}
                            </Card>
                          </div>
                        </div>
                        <div className="colTabPane">
                        <span className="label">
                              {t("Translate.Documents")}
                            </span>
                            <Form.Item name="eventDocuments">
                            <UploadDocuments
        initialFileList={initialuploadDoc}
        onFileListChange={(files) => setInitialUploadDoc(files)}
      />

     
                            </Form.Item>
                        </div>
                        </div>

                      </TabPane>
                      <TabPane
                        tab={t("Translate.Informations organisateur")}
                        key="3"
                      >
                        <div className="colTabPane">
                          <div className="input-form">
                            <span className="label">
                              {t("Translate.Nom de l'organizateur")}
                              <span className="require">*</span>
                            </span>
                            <Form.Item
                              name="organizerName"
                              rules={requiredFieldRule}
                            >
                              <Input
                                name="organizerName"
                                onChange={onChange}
                                placeholder={t(
                                  "Translate.Ajouter  nom de l'organizateur"
                                )}
                                initialValues={initialState?.organizerName}
                              />
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">
                              {t("Translate.Email de l'organizateur")}
                            </span>
                            <Form.Item
                              name="organizerEmail"
                              rules={[
                                {
                                  type: "email",
                                  message: t("Message.InvalidEmail"),
                                },
                              ]}
                            >
                              <Input
                                name="organizerEmail"
                                onChange={onChange}
                                initialValues={initialState?.organizerEmail}
                                placeholder={t(
                                  "Translate.Ajouter l'email de l'organisateur"
                                )}
                              />
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">
                              {t("Translate.phone_number")}
                            </span>
                            <Form.Item name="smsCount">
                              <Input
                                name="smsCount"
                                onChange={onChange}
                                placeholder={t("Translate.add_phone_number")}
                                initialValues={initialState?.smsCount}
                                inputMode="numeric"
                                onInput={(e) => {
                                  e.preventDefault();
                                  const inputValue = e.target.value;
                                  const numericValue = inputValue.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                  e.target.value = numericValue;
                                }}
                              />
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">
                              {t("Translate.Type d'accès")}
                            </span>
                            <Form.Item name="accessType">
                              <Select
                                name="accessType"
                                placeholder={t(
                                  "Translate.Sélectionner votre type d'accès"
                                )}
                                allowClear
                                onChange={(name, action) => {
                                  onChange_select("accessType", name, action);
                                }}
                              >
                                <Option
                                  name="accessType"
                                  key="1"
                                  value=""
                                  style={{ display: "none" }}
                                >
                                  <span className="accessText">
                                    {t(
                                      "Translate.Sélectionner votre type d'accès"
                                    )}{" "}
                                  </span>
                                </Option>
                                <Option
                                  name="accessType"
                                  key="1"
                                  value="Public"
                                >
                                  Public
                                </Option>
                                <Option
                                  name="accessType"
                                  key="2"
                                  value="LoginRequired"
                                >
                                  {t("showEvent.LoginRequired")}
                                </Option>
                                <Option
                                  name="accessType"
                                  key="3"
                                  value="Protected"
                                >
                                  {t("showEvent.protected")}
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <div className="input-form">
                            <span className="label">
                              {t("Translate.Commentaire")}
                            </span>
                            <Form.Item name="comment">
                              <Input.TextArea
                                name="comment"
                                onChange={onChange}
                                style={{ height: "108px" }}
                                placeholder={t(
                                  "Translate.Ajouter un commentaire"
                                )}
                                initialValues={initialState?.comment}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </TabPane>
                    </Tabs>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Spin>
        {/* DropDown Menu */}

        <Menu
          className="MenuCrop"
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleCloseMenu}
          style={{ zIndex: "999", top: "3%", left: "-6%", paddingBlock: "0" }}
        >
          <MenuItem>
            <div
              className="editClassRow"
              onClick={() => {
                updateImage();
              }}
            >
              <EditOutlined />
              <span className="EditItem">{t("Translate.Edit")}</span>
            </div>

            <input
              type="file"
              onChange={handleFileInputChange}
              style={{ display: "none" }}
              ref={fileInputRef}
              accept="image/*"
            />
          </MenuItem>

          <MenuItem
            disabled={!uploadLogoUrl && !initialState?.logoUrl ? true : false}
          >
            <div className="editClassRow">
              <DeleteOutlined />
              <span
                className="DeleteItem"
                onClick={() => {
                  onDelete();
                  //  setIsCropped(false);
                  setImage(null);
                  setInitialState((prev) => ({
                    ...prev,
                    logoUrl: null,
                    logo: "",
                  }));
                  handleCloseMenu();
                  dispatch({ type: "SET-LOADER", payload: true });
                }}
              >
                {t("Translate.Delete")}
              </span>
            </div>
          </MenuItem>
        </Menu>
      </Card>
    </div>
  );
}

export default AddEvents;
